exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "competition-player-list .player {\n  vertical-align: middle;\n  text-overflow: ellipsis; }\n  competition-player-list .player .player-name {\n    line-height: 30px;\n    margin-left: 3px;\n    white-space: normal; }\n    competition-player-list .player .player-name:hover {\n      text-decoration: underline;\n      cursor: pointer;\n      cursor: hand; }\n\ncompetition-player-list .player-image {\n  width: 30px;\n  margin-right: 5px; }\n\ncompetition-player-list .team-logo {\n  height: 50px;\n  margin-right: 10px; }\n\ncompetition-player-list section {\n  margin-bottom: 10px;\n  padding: 10px; }\n\ncompetition-player-list .mat-column-player {\n  -ms-flex: 1 0 50%;\n      flex: 1 0 50%; }\n\ncompetition-player-list .mat-column-handicap, competition-player-list .mat-column-status {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/competition-player-list/competition-player-list.component.scss
// module id = ../../../../../src/app/component-module/competition-player-list/competition-player-list.component.scss
// module chunks = main